import { HTTP } from '../../utils'

export const populatePerson = (uuid) => {
  return HTTP().get('/person/' + uuid)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
  })
}

export const deletePeople = (uuids) => {
  if (!uuids || !uuids.length || uuids.length <= 0) {
    return
  }
  return HTTP().delete('person/multiple?uuids=' + uuids)
  .then(response => {
    return response.data
  })
  .catch(e => {
    console.log('Error:' + e)
    return null
  })
}

export const savePerson = (personObj) => {
  return HTTP().put('/person/' + personObj.uuid, personObj)
    .then(response => {
      return response.data
    })
    .catch(e => {
      console.log('Error:' + e)
    })
}

export const doCsvUploadForPerson = (institutionId, createdByUuid, folderId, fileData) => {
  if (!institutionId || !createdByUuid || !folderId || !fileData) {
    return
  }
  let url = '/person/csvupload?createdByUuid=' + createdByUuid + '&folderId=' + folderId + '&institutionId=' + institutionId
  return HTTP().post(url, fileData)
  .then(res => {
    return res.data
  })
  .catch(e => {
    console.log(e)
  })
}



// WEBPACK FOOTER //
// ./src/app/person/api.js